<template>
    <div class="legal">
        <h1>Mentions légales</h1>
        <p><strong>Nom :</strong> Antoine Gonthier</p>
        <p><strong>Statut :</strong> Auto-entrepreneur</p>
        <p><strong>SIRET :</strong> 981247745</p>
        <p><strong>Adresse :</strong> 78 Rue de la Mélinière, 44000 Nantes, France</p>
        <p><strong>Email :</strong> contact@cognifynote.com</p>
    </div>
  </template>

  <script>
  export default {
    name: "LegalPage",
  };
  </script>

  <style scoped>
  .privacy {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    line-height: 1.6;
  }

  ul {
    margin-left: 20px;
  }

  a {
    color: #007bff;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
  </style>